import { InvalidAccessTokenException, InvalidCredentialsException, StoreNotIdentifiedException } from '@scalefast/core';
const AUTH_EXCEPTIONS = [{
  errorCode: '-50',
  exception: new StoreNotIdentifiedException()
}, {
  errorCode: '-22',
  exception: new StoreNotIdentifiedException()
}, {
  errorCode: '-200',
  exception: new StoreNotIdentifiedException()
}, {
  errorCode: '-11',
  exception: new InvalidCredentialsException()
}, {
  errorCode: '-211',
  exception: new InvalidAccessTokenException()
}];
export default AUTH_EXCEPTIONS;
